<div>
  <div #dt1 class="ui-g-12">
    <app-kontable [title] = "'Gestione Dizionario'"
                  [columns] = "[
                    { field: 'id', title: 'dictionaryOperation.id', filterType: numberFilter },
                    'company_id', 'nls_code', 'component', 'sub_component', 'value', 'info']"
                  [titles] = "['dictionaryOperation.company_id', 'dictionaryOperation.nls_code',
                               'dictionaryOperation.component', 'dictionaryOperation.sub_component', 'dictionaryOperation.value', 'dictionaryOperation.info']"
                  [service] = "dictionaryService"
                  [additionalRowCommands]="dictionaryAdditionalRowCommands"
                  [paginationType]="paginationType"
                  [showGlobalFilter]="false"
                  [showAddButton]="true"
                  [(fireNewDataAvailable)]="newDataAvailable"
                  (onAdd)="addEntry()"
                  (onEdit)="editEntry($event)"
                  (onDetails)="viewEntry($event)"
                  (onRemove)="removeEntry($event)"
                  (onRecover)="recoverEntry($event)">
      <ng-template #dictionaryAdditionalRowCommands data-testid="dictionaryAdditionalRowCommands" let-row>
        <p-button label="" pTooltip="{{ 'common.duplicate' | translate }}" icon="fa fas fa-clone" styleClass="ui-button-info" (onClick)="showDuplicateEntryDialog(row)"></p-button>
      </ng-template>

    </app-kontable>
  </div>

  <p-dialog
    *ngIf="showDetail"
    [width]="600"
    [(visible)]="showDetail"
    [header]="dialogTitle"
    [responsive]="true"
    showEffect="fade"
    (onHide)="closeDialogDetail()"
    [modal]="true">
    <div>
      <form *ngIf="fields" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="addEditForm" RestrictFocus>
        <h1 style="margin-bottom: 15px;">{{titleAction}}</h1>
        <input type="hidden" formControlName="id" pInputText>
        <div class="ui-grid ui-grid-responsive ui-fluid">
          <div *ngIf="currentAction == 'add' || currentAction == 'view' || currentAction == 'duplicate'" class="ui-grid-row bottom-10-margin">
            <div class="ui-grid-col-4">
              <label [ngClass]="{'required': !fields.company_id.nullable}">{{ fields.company_id.keyName }}</label>
            </div>
            <div class="ui-grid-col-8">
              <input type="number" formControlName="company_id" pInputText>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.company_id"></app-validation-msg>
            </div>
          </div>
          <div *ngIf="currentAction == 'add' || currentAction == 'view'" class="ui-grid-row bottom-10-margin">
            <div class="ui-grid-col-4">
              <label [ngClass]="{'required': !fields.nls_code.nullable}">{{ fields.nls_code.keyName }}</label>
            </div>
            <div class="ui-grid-col-8">
              <input type="text" formControlName="nls_code" pInputText>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.nls_code"></app-validation-msg>
            </div>
          </div>
          <div *ngIf="currentAction == 'add' || currentAction == 'view'" class="ui-grid-row bottom-10-margin">
            <div class="ui-grid-col-4">
              <label [ngClass]="{'required': !fields.component.nullable}">{{ fields.component.keyName }}</label>
            </div>
            <div class="ui-grid-col-8">
              <input type="text" formControlName="component" pInputText>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.component"></app-validation-msg>
            </div>
          </div>
          <div *ngIf="currentAction == 'add' || currentAction == 'view'" class="ui-grid-row bottom-10-margin">
            <div class="ui-grid-col-4">
              <label [ngClass]="{'required': !fields.sub_component.nullable}">{{ fields.sub_component.keyName }}</label>
            </div>
            <div class="ui-grid-col-8">
              <input type="text" formControlName="sub_component" pInputText>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.sub_component"></app-validation-msg>
            </div>
          </div>
          <div class="ui-grid-row bottom-10-margin">
            <div class="ui-grid-col-4">
              <label [ngClass]="{'required': !fields.value.nullable}">{{ fields.value.keyName }}</label>
            </div>
            <div class="ui-grid-col-8">
              <input type="text" formControlName="value" pInputText>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.value"></app-validation-msg>
            </div>
          </div>
          <div *ngIf="currentAction == 'add' || currentAction == 'view'" class="ui-grid-row bottom-10-margin">
            <div class="ui-grid-col-4">
              <label [ngClass]="{'required': !fields.info.nullable}">{{ fields.info.keyName }}</label>
            </div>
            <div class="ui-grid-col-8">
              <input type="text" formControlName="info" pInputText>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.info"></app-validation-msg>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div *ngIf="currentAction !== 'view'" class="ui-dialog-footer">
      <p-button type="button" styleClass="slim red-button" label="Cancel" (onClick)="showDetail = false"></p-button>
      <p-button type="button" styleClass="slim green-button" label="Ok" (onClick)="saveEntry()"></p-button>
    </div>
  </p-dialog>

  <p-dialog
    *ngIf="showDuplicateDialog"
    [width]="600"
    [height]="160"
    [(visible)]="showDuplicateDialog"
    [header]="'Conferma Duplicazione Termine di Dizionario'"
    [responsive]="true"
    showEffect="fade"
    [modal]="true">

    <div>
      <h1>Confermi la duplicazione dell'elemento selezionato?</h1>
    </div>

    <div class="ui-dialog-footer">
      <p-button type="button" styleClass="slim red-button" label="Cancel" (onClick)="showDuplicateDialog = false"></p-button>
      <p-button type="button" styleClass="slim green-button" label="Ok" (onClick)="confirmEntryDuplication()"></p-button>
    </div>

  </p-dialog>
</div>



// WEBPACK FOOTER //
// ./src/app/views/administration/dictionary/dictionary.component.html